<template>
  <el-card class="card tagCard">
    <div slot="header" class="tagCard__header">
      <strong class="tagCard__title">关联 Tag</strong>
      <button
        type="button"
        class="tagCard__addBtn"
        @click="dialogVisibleTag = true"
      >
        <i class="el-icon-plus" aria-hidden="true" />
        添加 Tag
      </button>
    </div>
    <div class="tagCard__body">
      <p class="tagCard__hint">
        已关联 Tag<span class="tagCard__hintMuted">（选填）</span>
      </p>
      <div class="tagCard__tags">
        <el-tag
          :key="tag.key"
          v-for="(tag, index) in tagList"
          closable
          :disable-transitions="false"
          @close="handleClose(index)"
          class="tagCard__pill"
        >
          {{ tag.name }}
        </el-tag>
        <span v-if="!tagList.length" class="tagCard__empty">暂未关联 Tag</span>
      </div>
    </div>

    <el-dialog
      title="关联Tag"
      :visible.sync="dialogVisibleTag"
      @before-close="dialogClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div>
        <el-card class="card">
          <div slot="header">
            <strong style="font-size: 14px">已关联</strong>
          </div>
          <div>
            <el-tag
              :key="tag.key"
              v-for="(tag, index) in tagList"
              closable
              :disable-transitions="false"
              @close="handleClose(index)"
              style="margin-right: 10px"
            >
              {{ tag.name }}
            </el-tag>
          </div>
        </el-card>
        <el-card class="card">
          <div slot="header">
            <strong style="font-size: 14px">可关联</strong>
          </div>
          <div>
            <div class="searchInputContainer">
              <div>
                <el-input
                  v-model="searchTag"
                  placeholder="搜索tag"
                  style="width: 200px"
                  size="mini"
                  @keyup.enter.native="getTagResource"
                  @input="getTagResource"
                ></el-input>
              </div>

              <div>
                <el-switch
                  v-model="isOpen"
                  active-text="全部展开"
                  inactive-text="不展开"
                  @change="showAllCollapse()"
                >
                </el-switch>
              </div>
            </div>

            <el-checkbox-group
              v-model="tagListStr"
              v-if="allTagList.length !== 0"
              @change="boxChange"
            >
              <el-collapse v-model="activeNames">
                <el-collapse-item
                  v-for="(item, index) in allTagList"
                  :key="item.key"
                  :name="index"
                >
                  <template slot="title">
                    <el-checkbox
                      :label="
                        JSON.stringify({ key: item.key, name: item.name })
                      "
                    >
                      <el-tooltip
                        effect="dark"
                        :content="item.name"
                        placement="top"
                      >
                        <div class="classifyLabel title">{{ item.name }}</div>
                      </el-tooltip>
                    </el-checkbox>
                  </template>
                  <div>
                    <div
                      v-for="itm in item.tagVOList"
                      :key="itm.key"
                      class="classifyLabelContainer"
                    >
                      <el-checkbox
                        :label="
                          JSON.stringify({ key: itm.key, name: itm.name })
                        "
                      >
                        <el-tooltip
                          effect="dark"
                          :content="itm.name"
                          placement="top-start"
                          :disabled="!disAble.includes(itm.key)"
                        >
                          <div
                            class="classifyLabel item"
                            @mouseenter="visibilityChange($event, itm.key)"
                          >
                            {{ itm.name }}
                          </div>
                        </el-tooltip>
                      </el-checkbox>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </el-checkbox-group>
            <el-empty description="结果为空" v-else :image-size="80"></el-empty>
          </div>
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogClose">取 消</el-button>
        <el-button size="mini" type="primary" @click="dialogClose"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import { nestedAll } from '../api/tagManage'
export default {
  name: 'tagCard',
  data() {
    return {
      tagList: this.tagVOList,
      tagListStr: [],
      dialogVisibleTag: false,
      searchTag: '',
      allTagList: [],
      timer: null,
      activeNames: [],
      isOpen: false,
      disAble: []
    }
  },
  props: {
    tagVOList: Array
  },
  created() {
    this.getAllParentTag()
    this.tagListStr = this.tagVOList.map((e) => {
      let data = JSON.stringify({ key: e.key, name: e.name })
      return data
    })
  },
  methods: {
    visibilityChange(event, key) {
      const ev = event.target
      const ev_weight = ev.scrollWidth // 文本的实际宽度   scrollWidth：对象的实际内容的宽度，不包边线宽度，会随对象中内容超过可视区后而变大。
      // const content_weight = this.$refs.tlp.$el.parentNode.clientWidth; // 文本容器宽度(父节点)
      if (ev_weight > 130) {
        // 实际宽度 > 可视宽度  文字溢出
        if (!this.disAble.includes(key)) {
          this.disAble.push(key)
        }
      }
    },
    showAllCollapse() {
      if (this.isOpen) {
        let list = []
        for (var i = 0; i < this.allTagList.length; i++) {
          list.push(i)
          this.activeNames = list
        }
      } else {
        this.activeNames = []
      }
    },
    getAllParentTag() {
      nestedAll(this.searchTag).then((res) => {
        if (res.success) {
          this.allTagList = res.data
          this.showAllCollapse()
        }
      })
    },
    boxChange() {
      this.tagList = this.tagListStr.map((e) => JSON.parse(e))
    },
    dialogClose() {
      this.dialogVisibleTag = false
      this.$emit('update:tagVOList', this.tagList)
    },
    handleClose(index) {
      this.tagList.splice(index, 1)
      this.tagListStr.splice(index, 1)
    },
    getTagResource() {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.getAllParentTag()
        this.showAllCollapse()
      }, 100)
    }
  }
}
</script>
<style scoped>
.card {
  margin-bottom: 20px;
}

.tagCard__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.tagCard__title {
  font-size: 14px;
}

.tagCard__addBtn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-height: 28px;
  padding: 0 12px;
  border: 1px dashed var(--link-accent-border, #cce5ff);
  border-radius: 999px;
  background: var(--link-accent-bg, #f0f7ff);
  font-size: 12px;
  font-weight: 500;
  color: var(--link-accent, #2563eb);
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.tagCard__addBtn:hover {
  border-color: var(--link-accent, #2563eb);
  background: var(--link-accent-soft, rgba(37, 99, 235, 0.07));
  color: var(--link-accent-hover, #1d4ed8);
}

.tagCard__body {
  padding-top: 2px;
}

.tagCard__hint {
  margin: 0 0 12px;
  font-size: 12px;
  color: var(--link-ink-secondary, #57534e);
}

.tagCard__hintMuted {
  color: var(--link-ink-muted, #78716c);
}

.tagCard__tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.tagCard__pill {
  margin: 0;
}

.tagCard__empty {
  font-size: 12px;
  color: var(--link-ink-muted, #78716c);
}
.classifyLabel {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 130px;
  /* line-height: 10px; */
}
.classifyLabelContainer {
  display: inline-block;
  height: 20px;
  margin-bottom: 20px;
}
.title {
  font-weight: 800;
  color: brown;
}
.item {
  color: gray;
}
.searchInputContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
::v-deep .el-checkbox__input {
  margin-top: -10px;
}
</style>
